// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mttvhemvwegbrhufodcx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im10dHZoZW12d2VnYnJodWZvZGN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU3MDAyMzUsImV4cCI6MjA3MTI3NjIzNX0.GMw772wkxQv23Bqv_N8VhkGxVV62H7SmCKSmfIlIyQI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});